import { VideoRender } from '@/components/ui/VideoRender';
import { ProfessionalTagChips } from '@/components/professional/ProfessionalTagChips';
import { cn } from '@/lib/utils';
import { useState } from 'react';

export interface ProfessionalCardProps {
	video_url?: string | null;
	profile_photo_url?: string | null;
	name_prefix?: string | null;
	first_name: string;
	last_name: string;
	crm_or_crp: string;
	service_name?: string;
	brief_description?: string | null;
	onClick: () => void;
	isSelected: boolean;
	highlight_tag?: Professionals.HighlightTag | null;
	main_approach?: Professionals.Approach | null;
	secondary_approaches?: Professionals.Approach[] | null;
	focus_topics?: Professionals.FocusTopic[] | null;
}

const ProfessionalCard = ({
	video_url,
	profile_photo_url,
	name_prefix,
	first_name,
	last_name,
	crm_or_crp,
	service_name,
	brief_description,
	onClick,
	highlight_tag,
	main_approach,
	secondary_approaches,
	focus_topics,
}: ProfessionalCardProps) => {
	const [isVideoPlaying, setIsVideoPlaying] = useState(false);

	const fullName = [name_prefix, first_name, last_name]
		.filter(Boolean)
		.join(' ');

	return (
		<div
			onClick={onClick}
			className={cn(
				'flex w-full flex-col items-center space-y-6 rounded-[2.5rem] border bg-white p-5 transition-all md:max-w-xs',
			)}
		>
			<div
				className={cn(
					'flex shrink-0 items-center justify-center overflow-hidden border-4 border-white bg-zinc-100 transition-all duration-500',
					isVideoPlaying
						? 'aspect-video w-full rounded-2xl'
						: 'size-32 rounded-full md:size-40',
				)}
			>
				<VideoRender
					videoUrl={video_url || ''}
					videoImage={profile_photo_url || ''}
					onStart={setIsVideoPlaying}
				/>
			</div>

			<div className="flex flex-col items-center space-y-2 text-center">
				{service_name && (
					<span className="text-[10px] font-black uppercase tracking-widest text-zinc-400">
						{service_name}
					</span>
				)}

				<div className="space-y-1">
					<h3 className="text-2xl font-bold leading-tight text-zinc-900">
						{fullName}
					</h3>

					<p className="text-[11px] font-black uppercase tracking-[0.2em] text-brand-pink">
						CRM/CRP {crm_or_crp}
					</p>
				</div>

				<ProfessionalTagChips
					highlight_tag={highlight_tag}
					main_approach={main_approach}
					secondary_approaches={secondary_approaches}
					focus_topics={focus_topics}
					className="w-full items-center"
				/>

				{brief_description && (
					<p className="line-clamp-3 text-sm font-medium leading-relaxed text-zinc-500">
						{brief_description}
					</p>
				)}
			</div>
		</div>
	);
};

export { ProfessionalCard };
